export default "__VITE_ASSET__D6D_1sLQ__"